import client from '../axios';
import { QueryParams } from '../types';
import {
  ReceivableRequest,
  ReceivableRequestV2,
  ReceivablesResponse,
} from './types';

const getReceivables = async (
  params: QueryParams
): Promise<ReceivablesResponse> => {
  const { search, page = 1, dateFrom, dateTo, enterpriseId, type } = params;
  const paramsUrl = new URLSearchParams();
  paramsUrl.append('page', `${page}`);
  if (search) paramsUrl.append('search', search);
  if (dateFrom) paramsUrl.append('dateFrom', dateFrom);
  if (dateTo) paramsUrl.append('dateTo', dateTo);
  if (type) paramsUrl.append('payinTypeId', type);

  const response = await client.get(
    `/enterprise/${enterpriseId}/receivables/?${paramsUrl.toString()}`
  );
  return response;
};

const generateRecivableRequest = ({
  enterpriseId,
  data,
}: ReceivableRequestV2): Promise<{ data: string }> =>
  client.post(`/enterprise/${enterpriseId}/receivables/`, data, {
    isAuthRedirect: false,
  });

// TODO: deprecated
const createReceivable = (
  receivable: ReceivableRequest,
  isPaymentLinkRequest: boolean
) => {
  const files: Record<string, File> = {};
  if (receivable.file) {
    receivable.file.forEach((file, index) => {
      files[`file-${index}`] = file;
    });
  }
  receivable.file = undefined;

  let items = {};
  receivable.items?.forEach((item, index) => {
    items = { ...items, [`item_${index + 1}`]: item };
  });

  const data = {
    ...receivable,
    ...files,
    items: JSON.stringify(items),
    city_state: receivable.cityState,
    due_date: receivable.dueDate,
    wallet_deposit: receivable.paymentPreference === 'efexWallet',
    taxes: 0,
  };

  return client.post(
    `/receivables/${isPaymentLinkRequest ? '?origin=link' : ''}`,
    data,
    {
      isAuthRedirect: false,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

const receivableSvc = {
  getReceivables,
  createReceivable,
  generateRecivableRequest,
};

export default receivableSvc;
